import { Link } from 'react-router-dom'

/**
 * Spec 160 (FR-005, FR-006, research D-160-06) — l'écran qui remplace la page quand le client désigné par l'adresse
 * n'est pas dans le périmètre de l'utilisateur, n'existe pas, est mal formé, ou que le serveur en refuse l'accès.
 *
 * Le MÊME écran dans tous ces cas, sans nom ni identifiant de client : rien ne doit dire si le client existe
 * (invariant 6a). Ce n'est pas la garde — le serveur refuse de son côté (invariants 1 et 3) —, c'est ce que
 * l'utilisateur lit à la place d'un message technique en anglais ou d'un tableau de bord vide.
 *
 * La mention du rechargement couvre la limite connue : le profil est chargé une fois par session, et un client affecté
 * pendant la session n'y entre qu'au rechargement.
 */
export function AccesRefuse({ lienRetour }: { lienRetour: string | null }) {
  return (
    <div role="alert" className="flex flex-col items-start gap-3 p-6 max-w-xl">
      <h1 className="font-heading text-h2 text-primary m-0">Vous n&apos;avez pas accès à ce client.</h1>
      <p className="font-body text-body text-muted-foreground m-0">
        L&apos;adresse ouverte désigne un client qui ne fait pas partie de ceux que vous pouvez consulter. Si cet accès
        vient de vous être donné, rechargez la page.
      </p>
      {lienRetour && (
        <Link to={lienRetour} className="font-body text-body text-accent underline hover:text-primary">
          Revenir à vos données
        </Link>
      )}
    </div>
  )
}
